// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q5-1";
export var stateContainer = "_q5-0";